import React from 'react'
import styles from './notice.module.css'
import homeStyles from '../home/home.module.css'
import mainStyles from '../app.module.css'
import logo from '../../@assets/logo.svg'
import number1Icon from '../../@assets/home/number1.svg'
import number2Icon from '../../@assets/home/number2.svg'
import warning from '../../@assets/apply/warning_icon.svg'
import Footer from '../common/Footer'

const APPLICATION_FORM_URL =
  'https://modoosol0.sharepoint.com/:w:/s/modoosol.com/IQBV7OdaaP1kRp1OIUomTiyHAbOpWn4ZJtqf5iYBuDn6TlA?e=Sx8N20'
const LICENSE_EMAIL = 'license@modoosol.com'

function Notice() {
  return (
    <div className={mainStyles.wrapper}>
      <main className={mainStyles.main}>
        <section className={homeStyles.wrapper}>
          <div className={homeStyles.container}>
            <div className={homeStyles.comp_title}>
              <img src={logo} alt="" />
              <h1>라이선스 초기화 신청</h1>
            </div>

            <div className={homeStyles.comp_wrap}>
              <div className={homeStyles.comp_box}>
                <h2 className={styles.notice_title}>[안내] 라이선스 초기화 신청 방법 임시 변경</h2>

                <p className={styles.notice_text}>
                  현재 웹 서버 보안 취약점 예방 조치 및 전반적인 시스템 보안 점검을 진행하고 있습니다.
                </p>
                <p className={styles.notice_text}>
                  이에 따라 안전한 보안 환경 구축을 위해 라이선스 초기화 신청 사이트 운영이 잠시 중단됩니다.
                  <br />
                  시스템 점검이 완료되면 기존 사이트를 정상적으로 이용하실 수 있으며, 점검 기간 중 라이선스 초기화가 필요하신
                  고객님께서는 아래 방법을 참고하시어 이메일로 접수해 주시기 바랍니다.
                </p>

                <h2 className={homeStyles.comp1_title}>라이선스 초기화 신청 방법</h2>
                <ul>
                  <li className={homeStyles.info_box}>
                    <img src={number1Icon} alt="" />
                    <div>
                      <p>라이선스 초기화 신청서를 다운로드하여 작성해 주십시오.</p>
                      <a
                        href={APPLICATION_FORM_URL}
                        className={styles.download_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        라이선스 초기화 신청서 다운로드
                      </a>
                    </div>
                  </li>
                  <li className={homeStyles.info_box}>
                    <img src={number2Icon} alt="" />
                    <div>
                      <p>작성한 신청서 하단에 반드시 서명하거나 직인을 날인해 주십시오.</p>
                      <p className={styles.caution}>
                        ※ 서명 또는 직인 날인이 누락된 신청서는 초기화 처리가 불가능합니다.
                      </p>
                    </div>
                  </li>
                  <li className={homeStyles.info_box}>
                    <span className={styles.step_number}>3</span>
                    <div>
                      <p>
                        서명/직인이 포함된 신청서 스캔본과 사업자등록증 사본을 함께{' '}
                        <a href={`mailto:${LICENSE_EMAIL}`} className={styles.email_link}>
                          {LICENSE_EMAIL}
                        </a>
                        으로 보내 주십시오.
                      </p>
                      <p className={styles.caution}>
                        ※ 개인 명의 구매자는 사업자등록증 대신 신분증 사본(주민등록번호 뒷자리는 반드시 마스킹(가림) 처리 후
                        제출)을 보내 주십시오.
                      </p>
                    </div>
                  </li>
                </ul>

                <div className={homeStyles.guide_wrap_non_margin}>
                  <img src={warning} alt="" />
                  <p>
                    라이선스 초기화 처리는 영업일 기준 1~2일이 걸릴 수 있으며, 완료되면 메일로 안내드립니다.
                    <br />
                    초기화 관련 문의사항은 <a href="tel:02-857-0974" className={styles.email_link}>02-857-0974</a>로 연락 주시기 바랍니다.
                  </p>
                </div>

                <p className={styles.notice_text}>
                  갑작스러운 시스템 점검으로 인해 이용에 불편을 드려 죄송하며, 너그러운 양해와 협조를 부탁드립니다.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default Notice
